import { MetricGroupId } from '../../../../../common/graphql/generated/graphql-sdk';
import { getMetricGroupIdFromFrontendMetricGroupId } from '../../../../../common/metrics/backendMetricMappings';
import { MetricStore } from '../../../../../common/metrics/metric-store';
import { recruitmentFrontendMetricGroups } from '../../../../../common/recruitment/recruitment-store';
import { Alias } from '../../../../../common/v2/api/alias/types';
import { Languages } from '../../../../../common/v2/constants';
import { BalanceSheetStore } from '../../balance-sheet-store';
import { PbsTableService } from '../../services/PbsTableService';

const name = 'recruitment-balance-sheet';
const dashboardLinkKey = 'recruitment-balance-sheet';

const recruitmentMetricGroups = recruitmentFrontendMetricGroups.map((g) =>
  getMetricGroupIdFromFrontendMetricGroupId(g)
);
const initialCheckedPbsValues: MetricGroupId[] = recruitmentMetricGroups;

const balanceSheetTableService = PbsTableService;

export const getRecruitmentBalanceSheetStoreInstance = (
  metricStore: MetricStore,
  aliases: Alias[],
  selectedLanguage: Languages
) =>
  new BalanceSheetStore(metricStore, aliases, selectedLanguage, {
    name,
    initialCheckedPbsValues,
    dashboardLinkKey,
    balanceSheetTableService,
    configuredMetricGroups: recruitmentMetricGroups,
  });
